export default "__VITE_ASSET__Ba70OOkQ__"